import {keySvg as Icon__small__keySvg} from '../Icon__small/Icon__small--key.js';

export var key = {
  name: 'key',
  category: 'icon',
  colorable: true,
  svg: Icon__small__keySvg,
};
